import React from "react";
import styles from "../styles/about.module.css";
import Skills from "./Skills";

const About = () => {
  return (
    <div className={styles.about}>
      <h1>
        <span style={{ color: "#3ABFF8" }}>👨🏻‍💻</span> About Me
      </h1>
      <p style={{ marginTop: "2rem" }}>
        Hello, I'm Amit Rai from India, I have been doing full-stack development
        for <span style={{ color: "#84e1cd" }}>over 2 years </span>
        and have completed two frontend developer internships at a startup, one
        of which was a <span style={{ color: "#84e1cd" }}>YC startup</span>.
      </p>
      <p style={{ marginTop: "1rem" }}>
        I have solid experience with{" "}
        <span style={{ color: "#84e1cd" }}>
          ReactJS, Angular, NextJS, JavaScript, Express.js, MongoDB.{" "}
        </span>
        I have developed many web development projects such as E-commerce
        application, Blogging web app, Code Canvas, Netflix clone, etc. Also, I
        have solved over <span style={{ color: "#84e1cd" }}>450+</span> Data
        Structures and Algorithms problems on leetcode and participated in
        various coding contests.
      </p>
      <Skills />
    </div>
  );
};

export default About;
